import { render, staticRenderFns } from "./CatalogCategoriesExport.vue?vue&type=template&id=e5ddc806&"
import script from "./CatalogCategoriesExport.vue?vue&type=script&lang=js&"
export * from "./CatalogCategoriesExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports